import { engineComponent, NumberUtils } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { BetElement } from "./BetElement";
import { ShapeElement } from "../Components/Elements/Graphics/ShapeElement";
import { RouletteView } from "./Roulette/RouletteView";
import { RouletteBetConfiguration } from "../CustomComponents/RouletteBetConfiguration";
import { BetManager } from "../Managers/BetManager";
import { ImageTextElement } from "../Components/Elements/Texts/ImageTextElement";
import { StyleManager } from "../Components/Managers/StyleManager";
import { LayoutContainerElement } from "../CustomComponents/LayoutContainerElement";
import { LayoutSwitchElement } from "../CustomComponents/LayoutSwitchElement";
import { Bet } from "./Bet";
import { CustomUtils } from "../Utils/CustomUtils";

@engineComponent(ComponentTypes.DisplayObject)
export class GridPossibleWins extends ContainerElement {
    private static readonly GridBetValueStyle: string = "SS_gridPossibleWinValue";
    private static readonly PortraitGridBetValueStyle: string = "SS_portraitGridPossibleWinValue";

    private possibleWinElements: { [id: string]: LayoutSwitchElement };
    private possibleWinValues: { [id: string]: number };

    public initialize(betElements: { [id: string]: BetElement }): void {
        this.possibleWinElements = {};
        this.possibleWinValues = {};

        for (let i = 0; i < RouletteBetConfiguration.Single.length; i++) {
            const type = "Single_" + RouletteBetConfiguration.Single[i];
            const betElement = betElements[type];

            if (betElement != null) {
                let value = this.createValue("PossibleWin_" + i);
                value.x = betElement.x;
                value.y = betElement.y;

                this.possibleWinElements[type] = value;
                this.possibleWinValues[type] = 0;
                this.addChild(value);
            }
        }
    }

    private createValue(nodeName: string): LayoutSwitchElement {
        let node: Element = document.createElement(nodeName);
        node.setAttribute("Style", GridPossibleWins.GridBetValueStyle);
        node.setAttribute("Case", "EMPTY");
        node.setAttribute("Clone", "true");

        if (StyleManager.Styles[GridPossibleWins.PortraitGridBetValueStyle] != null) {
            node.setAttribute("PortraitStyle", GridPossibleWins.PortraitGridBetValueStyle);
        }

        let elem = new LayoutSwitchElement();
        elem.create(node);

        //add value background to table color elements
        let valueBg = <ShapeElement>elem.getChildElementByName("Highlight");
        RouletteView.addColorShapeElement(valueBg);

        return elem;
    }

    public updatePossibleWins(bets: Array<Bet> = null): void {
        bets = bets ? bets : BetManager.getPlacedBets();
        this.resetPossibleWins();

        for (let i = 0; i < bets.length; i++) {
            const bet = bets[i];
            const numbersAffected = BetManager.getBetNumbersByBetType(bet.type, bet.selection);
            const multiplier = BetManager.getBetMultiplierByBetType(bet.type);
            const value = bet.value;

            for (let j = 0; j < numbersAffected.length; j++) {
                this.updateSinglePossibleWin("Single_" + numbersAffected[j], value, multiplier);
            }
        }

        this.showPossibleWins();
    }

    private updateSinglePossibleWin(type: string, value: number, multiplier: number): void {
        let possibleWinValue = this.possibleWinValues[type];

        if (possibleWinValue != null) {
            possibleWinValue = parseFloat(NumberUtils.add(possibleWinValue, NumberUtils.multiply(value, multiplier)));
            this.possibleWinValues[type] = possibleWinValue;
        }
    }

    private showPossibleWins(): void {
        if (this.possibleWinElements != null) {
            for (let key in this.possibleWinElements) {
                const value = this.possibleWinValues[key];

                if (value > 0) {
                    const valueElement = <ImageTextElement>this.possibleWinElements[key].getChildElementByName("Value");
                    valueElement.bitmapText.text = CustomUtils.abbreviateNumber(value);
                    valueElement.realign();

                    this.possibleWinElements[key].goToCase("NORMAL");
                }
            }
        }
    }

    public hidePossibleWins(winNumber: number): void {
        if (this.possibleWinElements != null) {
            for (let key in this.possibleWinElements) {
                if (this.possibleWinElements[key].getCurrentCase() == "NORMAL") {
                    if (key == "Single_" + winNumber) {
                        this.possibleWinElements[key].goToCase("HIDE_WIN");
                    } else {
                        this.possibleWinElements[key].goToCase("HIDE");
                    }
                }
            }
        }
    }

    public resetPossibleWins(): void {
        if (this.possibleWinElements != null) {
            for (let key in this.possibleWinElements) {
                this.possibleWinElements[key].goToCase("EMPTY");
                this.possibleWinValues[key] = 0;
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/GridPossibleWins.ts
 **/